import { TapResponseFrame, TapRequestFrame } from '@iotize/tap/client/api';
import {
  HostProtocol,
  TargetProtocol,
  VariableFormat,
  AppPathType,
  SpecialFeature,
  TapVersion,
  CpuFrequencySpeed,
} from '@iotize/tap';

/* eslint-disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export interface ModbusVariableAddress {
  functionCode: number;
  slave: number;
  address: number;
}

/* eslint-disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export interface VariableType {
  domain: VariableType.Domain;
  data: VariableType.Data;
}

export namespace VariableType {
  /* eslint-disable */
  /**
   * This file was automatically generated by json-schema-to-typescript.
   * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
   * and run json-schema-to-typescript to regenerate this file.
   */

  export enum Data {
    BOOLEAN = 0,
    INT8 = 1,
    INT16 = 2,
    INT32 = 3,
    ASCII = 8,
    FLOAT32 = 19,
    UINT8 = 33,
    UINT16 = 34,
    UINT32 = 35,
  }

  /* eslint-disable */
  /**
   * This file was automatically generated by json-schema-to-typescript.
   * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
   * and run json-schema-to-typescript to regenerate this file.
   */

  export enum Domain {
    TARGET = 0,
    GPIO = 1,
    IN_TAP_STATIC = 2,
    IN_TAP_VOLATIL = 3,
  }
}

/* eslint-disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export interface VariableMeta {
  name: string;
  unit: string;
}
